import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function Audience() {
  return <Section background="white" data-id="element-58">
      <div className="text-center mb-10" data-id="element-59">
        <h2 className="text-3xl font-extrabold text-gray-800" data-id="element-60">
          Para quién es (y para quién no)
        </h2>
      </div>
      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-61">
        <div className="bg-gradient-to-br from-[#E6F4F4] to-[#D4EFED] p-8 rounded-3xl" data-id="element-62">
          <h3 className="text-xl font-bold text-[#4AAAA5] mb-6 flex items-center" data-id="element-63">
            <CheckCircle2 className="mr-2" data-id="element-64" /> Es para ti si…
          </h3>
          <ul className="space-y-4" data-id="element-65">
            <li className="flex items-start" data-id="element-66">
              <span className="mr-3 mt-1.5 w-2 h-2 bg-[#4AAAA5] rounded-full flex-shrink-0" data-id="element-67"></span>
              <span className="text-gray-700" data-id="element-68">
                Tus mañanas se vuelven pelea por cosas pequeñas
              </span>
            </li>
            <li className="flex items-start" data-id="element-69">
              <span className="mr-3 mt-1.5 w-2 h-2 bg-[#4AAAA5] rounded-full flex-shrink-0" data-id="element-70"></span>
              <span className="text-gray-700" data-id="element-71">
                Quieres límites firmes sin vivir gritando
              </span>
            </li>
            <li className="flex items-start" data-id="element-72">
              <span className="mr-3 mt-1.5 w-2 h-2 bg-[#4AAAA5] rounded-full flex-shrink-0" data-id="element-73"></span>
              <span className="text-gray-700" data-id="element-74">
                Quieres una herramienta visual, práctica y rápida
              </span>
            </li>
          </ul>
        </div>

        <div className="bg-gradient-to-br from-[#FFF5F0] to-[#FFEDD5] p-8 rounded-3xl" data-id="element-75">
          <h3 className="text-xl font-bold text-[#E8845F] mb-6 flex items-center" data-id="element-76">
            <XCircle className="mr-2" data-id="element-77" /> No es para ti si…
          </h3>
          <ul className="space-y-4" data-id="element-78">
            <li className="flex items-start" data-id="element-79">
              <span className="mr-3 mt-1.5 w-2 h-2 bg-[#E8845F] rounded-full flex-shrink-0" data-id="element-80"></span>
              <span className="text-gray-700" data-id="element-81">
                Buscas que "obedezca perfecto" sin que tú sostengas nada
              </span>
            </li>
            <li className="flex items-start" data-id="element-82">
              <span className="mr-3 mt-1.5 w-2 h-2 bg-[#E8845F] rounded-full flex-shrink-0" data-id="element-83"></span>
              <span className="text-gray-700" data-id="element-84">
                No estás dispuesto/a a probarlo 7–14 días
              </span>
            </li>
            <li className="flex items-start" data-id="element-85">
              <span className="mr-3 mt-1.5 w-2 h-2 bg-[#E8845F] rounded-full flex-shrink-0" data-id="element-86"></span>
              <span className="text-gray-700" data-id="element-87">
                Quieres una solución mágica sin guía inicial
              </span>
            </li>
          </ul>
        </div>
      </div>
    </Section>;
}